import { useState, useEffect } from 'react'
import i18n from 'i18next'
import { RecoilRoot } from 'recoil'
import { useCookies } from 'react-cookie'
import axios from 'axios'

import { createWeb3Modal, defaultConfig } from '@web3modal/ethers5/react'

import '../src/stylesheets/style.scss'

import SideNav from './components/SideNav'
import PlayArea from './components/PlayArea'
import ConnectArea from './components/ConnectArea'
// import OpenMetaMaskModal from './components/OpenMetaMaskModal'

import Routing from '../entrypoints/routing'

type Props = {
  page?: string
}

interface Window {
  location: Location
  navigator: {
    language: string
  }
}
declare let window: Window

function App(props: Props) {
  const [web3, setWeb3] = useState({} as Web3)
  const [, setCookie, removeCookie] = useCookies()

  // 特定のページでMetaMaskの立ち上げを促すモーダルを表示させないための設定
  // const unOpenPagePath = [
  //   'articles',
  //   'others',
  //   'contact',
  //   'playlist',
  //   'serials',
  // ]
  // const isPageInUnopenPath = unOpenPagePath.some((path) =>
  //   location.pathname.includes(path)
  // )

  useEffect(() => {
    // ブラウザの設定言語にあわせてi18nの設定言語を変更
    const userLanguage = window.navigator.language
    if (userLanguage !== 'ja') {
      i18n.changeLanguage('en')
    } else {
      i18n.changeLanguage(userLanguage)
    }
    setCSRF()
    setAxios()
  }, [])

  const setAxios = () => {
    axios.defaults.xsrfCookieName = 'CSRF-TOKEN'
    axios.defaults.xsrfHeaderName = 'X-CSRF-Token'
    axios.defaults.withCredentials = false
  }

  const setCSRF = async () => {
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute('content')
    if (!csrfToken) return

    removeCookie('CSRF-TOKEN', { path: '/' })
    setCookie('CSRF-TOKEN', csrfToken, {
      path: '/',
      secure: import.meta.env.VITE_STAGING === 'production',
      sameSite: 'lax',
    })
  }

  // WalletConnect ====================
  const projectId = 'ef091b8c0bbff7280c7a620b4f4e08c0' // WalletConnect Project ID

  // Set chains
  const mainnet = {
    chainId: 1,
    name: 'Ethereum',
    currency: 'ETH',
    explorerUrl: 'https://etherscan.io',
    rpcUrl: 'https://cloudflare-eth.com',
  }

  const polygon = {
    chainId: 137,
    name: 'Polygon',
    currency: 'MATIC',
    explorerUrl: 'https://polygonscan.com/',
    rpcUrl: 'https://polygon-rpc.com/',
  }

  const astar = {
    chainId: 592,
    name: 'Astar Network Mainnet',
    currency: 'ASTR',
    explorerUrl: 'https://astar.subscan.io/',
    rpcUrl: 'https://evm.astar.network',
  }

  // Create Modal
  const metadata = {
    name: 'Sound Desert',
    description: 'Sound Desertは音楽NFTのための音楽プレイヤーです。',
    url: 'https://sound-desert.com',
    icons: [
      'https://d2tr0ey4qw5bcr.cloudfront.net/shared/apple-touch-icon.png',
    ],
  }

  createWeb3Modal({
    ethersConfig: defaultConfig({ metadata }),
    chains: [mainnet, polygon, astar],
    projectId,
    termsConditionsUrl: 'https://sound-desert.com/others/terms_fan',
    privacyPolicyUrl: 'https://sound-desert.com/others/privacy',
  })

  // WalletConnect END ====================

  return (
    <RecoilRoot>
      <SideNav />
      <main className="main">
        <ConnectArea setWeb3={setWeb3} />
        <Routing page={props.page} web3={web3} />
        <PlayArea />
        {/* {!isPageInUnopenPath && <OpenMetaMaskModal />} */}
      </main>
    </RecoilRoot>
  )
}

export default App
